import mutations from "@/store/mutations/settingDataMutation";
import actions from "@/store/actions/settingDataAction";
import getters from "@/store/getters/settingDataGetter";
/**
 * [GX] SETTING DATA
 */
export default {
  state: {
    settingData: null,
    localizePrice: null,
    judgeInterFaceExist: true, // 判断jsBridge后期新增的接口是否存在于原生包中
    subsSetting: {
      arrival_speed: 'Fast',
      dynamic_likes: 'Open'
    },
    takeDownOperateNums: 0,
    unInstalledList: [],
    front: true
  },
  mutations,
  actions,
  getters
};
